import styled, { css } from 'styled-components';
import ScrollSlider from '../ScrollSlider';
import TimeOffCard from '../TimeOffCard';

const hideScroll = css`
  overflow: hidden;
`;

export const ButtonCards = styled(ScrollSlider)<{ $hideScroll?: boolean }>`
  display: flex;
  justify-content: center;
  margin: 0 -6px;

  & > div {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    overflow-y: auto;
    padding: 6px;
    width: 100%;
    ${({ $hideScroll = false }) => $hideScroll && hideScroll}
  }
`;

export const Card = styled(TimeOffCard)`
  width: 100%;
  min-width: 175px;
  flex-shrink: 0;
`;
